import React from "react";
import { Text, Flex } from "@fluentui/react-northstar";
import { PropTypes } from "prop-types";

const TextContentComponent = (props) => {
  const { text, component, testId } = props;

  return (
    <Flex vAlign="center" gap="gap.small" className="text-component" data-testid={testId}>
      <Text data-testid={testId + "Text"}>{text}</Text>
      {component}
    </Flex>
  );
};

TextContentComponent.propTypes = {
  text: PropTypes.string,
  component: PropTypes.object,
  testId: PropTypes.string,
};

TextContentComponent.defaultProps = {
  text: "",
  component: null,
  testId: "",
};

export default TextContentComponent;
